export const GET_SECURITY_UNLOADING_REPORTS_REQUEST = 'GET_SECURITY_UNLOADING_REPORTS_REQUEST' as const;
export const GET_SECURITY_UNLOADING_REPORTS_SUCCESS = 'GET_SECURITY_UNLOADING_REPORTS_SUCCESS' as const;
export const GET_SECURITY_UNLOADING_REPORTS_ERROR = 'GET_SECURITY_UNLOADING_REPORTS_ERROR' as const;

export const fieldsNames = [
  'alloweWeight',
  'arrivalSecurityGateId',
  'branchName',
  'departureDateTime',
  'departureSecurityGateId',
  'departureWeight',
  'driverDocumentNumber',
  'driverName',
  'driverPhone',
  'entryDateTime',
  'entryWeight',
  'forwarderName',
  'forwarderPhone',
  'packingLists',
  'securityMessage',
  'sgName',
  'trailerLicensePlate',
  'tripId',
  'vehicleLicensePlate',
];
